import { Field } from '../../../../Field'
import { COLOR_PICKER_DEFAULT_HEX } from '../../../ColorPicker.constants'
import { isColorFormatRgb } from '../../../ColorPicker.utils'
import { getRgbFromHex } from '../../ColorPickerPopover.utils'

import * as styles from '../ColorPickerPopoverPreview.module.css'

function ColorPickerPopoverPreviewReadonly({
  className,
  color,
  colorFormat,
  info,
  label,
}) {
  const rgb = getRgbFromHex(color || COLOR_PICKER_DEFAULT_HEX)

  return (
    <div className={className}>
      <Field
        className={styles.fieldRoot}
        fieldInputClassName={styles.fieldInputRow}
        info={info}
        label={label}
        labelClassName={styles.label}
        labelTextProps={{
          className: styles.labelText,
        }}
      >
        {isColorFormatRgb(colorFormat) ? (
          <div className={styles.rgbValueBlock}>
            <span
              className={styles.swatch}
              style={{ backgroundColor: color }}
            />
            <span className={styles.rgbValue}>{rgb.r}</span>
            <span className={styles.rgbValue}>{rgb.g}</span>
            <span className={styles.rgbValue}>{rgb.b}</span>
          </div>
        ) : (
          <div className={styles.valueBlock}>
            <span
              className={styles.swatch}
              style={{ backgroundColor: color }}
            />
            <span className={styles.colorValue}>{color}</span>
          </div>
        )}
      </Field>
    </div>
  )
}

export default ColorPickerPopoverPreviewReadonly
